import React from 'react';
import styles from './delete-confirm.module.sass';
import { Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export const confirmDeleteSharedSource = ({ source, onOk, onCancel }) => {
  // console.log('source', source);
  Modal.confirm({
    className: styles.container,
    title: `Are you sure you want to delete ${source?.name}?`,
    icon: <DeleteOutlined />,
    content: (
      <>
        <p
          style={{
            color: 'rgba(255, 255, 255, 0.65)',
            fontSize: '14px',
            lineHeight: '18px',
          }}
        >
          You are about to permanently delete the source shared with your
          organization.
          <br />
          <br />
          {source?.name}
          <br />
          was created by {source?.creator}
          <br />
          it has {source?.ioc_count ?? 'n/a'} observables
        </p>

        <p style={{ fontSize: '14px', lineHeight: '16px' }}>
          The source will be deleted for everyone in the organization!
          <br />
          You can't undo this action!
        </p>
      </>
    ),
    onOk() {
      onOk();
    },
    onCancel() {
      onCancel && onCancel();
    },
    okText: 'Delete',
    cancelText: 'Close',
    cancelButtonProps: {
      type: 'default',
    },
    okButtonProps: {
      danger: true,
    },
  });
};
